import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
/*
const defaultProps = {
  label: '',
  helpText: '' as string | React.ComponentType,
  type: 'text' as
    | 'text'
    | 'password'
    | 'button'
    | 'checkbox'
    | 'radio'
    | 'color'
    | 'date'
    | 'datetime'
    | 'datetime-local'
    | 'email'
    | 'file'
    | 'hidden'
    | 'number'
    | 'password'
    | 'range',
  name: '',
  placeholder: '',
  leftIcon: '',
  rightIcon: '',
  inputProps: {} as React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  required: false,
  invalid: false,
  disabled: false,
};
*/

export var InputField = function (_a) {
  var LeftIcon = _a.leftIcon,
      RightIcon = _a.rightIcon,
      label = _a.label,
      helpText = _a.helpText,
      prepend = _a.prepend,
      append = _a.append,
      invalid = _a.invalid,
      valid = _a.valid,
      inputProps = __rest(_a, ["leftIcon", "rightIcon", "label", "helpText", "prepend", "append", "invalid", "valid"]);

  var inputClassName = classNames("input-group", {
    "has-icon-prepend": LeftIcon
  }, {
    "has-icon-append": RightIcon
  }, {
    "is-required": inputProps.required
  });
  return React.createElement("div", {
    className: "form-group"
  }, label && React.createElement("label", {
    className: "form-input-label"
  }, label), React.createElement("div", {
    className: inputClassName
  }, prepend && React.createElement("div", {
    className: "input-group-prepend"
  }, React.createElement("span", {
    className: "input-group-text"
  }, prepend)), React.createElement("input", __assign({
    className: "form-control"
  }, inputProps)), append && React.createElement("div", {
    className: "input-group-append"
  }, React.createElement("span", {
    className: "input-group-text"
  }, append)), LeftIcon && React.createElement("div", {
    className: "input-group-icon-prepend"
  }, React.createElement("span", {
    className: "input-group-icon"
  }, React.createElement(LeftIcon, {
    color: "black",
    size: "24px"
  }))), RightIcon && React.createElement("div", {
    className: "input-group-icon-append"
  }, React.createElement("span", {
    className: "input-group-icon"
  }, React.createElement(RightIcon, {
    color: "black",
    size: "24px"
  })))), helpText && (typeof helpText === "string" ? React.createElement("small", {
    className: classNames({
      "form-text text-muted": !valid && !invalid,
      "invalid-feedback": invalid,
      "valid-feedback": valid
    })
  }, helpText) : helpText));
};